// extracted by mini-css-extract-plugin
export default {"container":"BoxShadowInput_container__e2t+F"};